import React, { useEffect, useState } from "react";
import {
  Modal,
  IconButton ,
  Typography,
  Card,
  Grid,
  InputLabel,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Tooltip,
  CircularProgress,
  Alert, 
  AlertTitle,
  MenuItem,
  Slider,
  Box
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getTradeChannels,getSubTradeChannels,GetTradeConfiguration} from "../../utils/GetAdmin";
import {checkForRole} from "../../utils/GetAuth";
import { saveTradeConfiguration} from "../../utils/PostAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import Help from "@mui/icons-material/Help";
import Select, { SelectChangeEvent } from '@mui/material/Select';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

export default function TradeSubtradeConfig() {
    const classes = useStyles();
    const [tradeChannels, setTradeChannels] = React.useState<any>();
    const [subTradeChannels, setSubTradeChannels] = React.useState<any>();
    const [editedRowTradeChannels, setEditedRowTradeChannels] = React.useState<string>("*");
    const [editedRowSubTradeChannels, setEditedRowSubTradeChannels] = React.useState<string>("*");
    const [rowGuid, setRowGuid] = React.useState<any>();

    const MAX = 100;
    const MIN = 0;
    const marks = [
      {
        value: MIN,
        label: '',
      },
      {
        value: MAX,
        label: '',
      },
    ];
    const [fsvVal, setVal] = React.useState<number>(MIN); 
    const [convenienceVal, setConvenienceVal] = React.useState<number>(MIN); 

    const handleChange = (_: Event, newValue: number | number[]) => {
      setVal(newValue as number);
    };
    const handleConvenienceChange = (_: Event, newValue: number | number[]) => {
      setConvenienceVal(newValue as number);
    };
    const [tradeSubtradeConfig, SetTradeSubtradeConfig] = useState<any[]>([]);
    const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
    const [doneLoading, setDoneLoading] = React.useState<boolean>();
    const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
    const enabled = checkForRole(clientId,salesOrg,'vp_admin');
    const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
    const [useCompact] = useLocalStorage("SETTINGS.compact", true);
    

   
    const handleDelete = () => {
      let newmapdata = {tradeChannel: editedRowTradeChannels, subTradeChannel:editedRowSubTradeChannels, fsv:fsvVal,convenience:convenienceVal};

      saveTradeConfiguration(salesOrg,newmapdata,undefined).then((ret:any) => {
        if(ret && ret.mdEquipmentModelMap){
          SetTradeSubtradeConfig(ret.mdEquipmentModelMap)
          if(ret.data.message){
            alert(ret.data.message);
          }
        }
      });
      setEditedRow(undefined);
    }
    const setCurrent = (editedRow:any) => {
      setEditedRow(editedRow);
      setRowGuid(editedRow.guid);
      setEditedRowTradeChannels(editedRow.trade_channel);
      if(editedRow.trade_channel!=='*') {
        getSubTradeChannels(salesOrg,editedRow.trade_channel).then((v) => {
          setSubTradeChannels(v.result);
        })
      }else{
        setSubTradeChannels("");
      }
      setEditedRowSubTradeChannels(editedRow.sub_trade_channel);
      setVal(editedRow.fsv_percentage);
      setConvenienceVal(editedRow.convenience_percentage);
      
    }
    const clearCurrent = () => {
      setEditedRow(undefined);
      setEditedRowTradeChannels("*");
      setEditedRowSubTradeChannels("*");
      setVal(0);
      setConvenienceVal(0);
    }
    const handleEdit = (editedRow:any) => {
      setCurrent(editedRow);
      setOpenEditWindow(true);
    }
    const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);
    const [modalStyle] = React.useState(getModalStyle);
    const [openDeleteWindow, setopenDeleteWindow] = React.useState(false);
    const [openEditWindow, setOpenEditWindow] = React.useState(false);
    const handleModalClose = () => {
      setOpenEditWindow(false);
      setEditedRowTradeChannels("*");
      clearCurrent();
      setEditedRow(undefined);
    }
    const handleModalSave = () => {
      
      let newmap = {tradeChannel: editedRowTradeChannels, subTradeChannel:editedRowSubTradeChannels, fsv:fsvVal,convenience:convenienceVal,guid:rowGuid};

      saveTradeConfiguration(salesOrg,undefined,newmap).then((ret:any) => {
        if(ret && ret.mdEquipmentModelMap){
          SetTradeSubtradeConfig(ret.mdEquipmentModelMap);
        }
      });
      setOpenEditWindow(false);
      setEditedRow(undefined);
    } 
    useEffect(() => {
      if (doneLoading) return;
      GetTradeConfiguration(salesOrg).then((v) => {
        setDoneLoading(true);
        if(v && v.mdEquipmentModelMap) SetTradeSubtradeConfig(v.mdEquipmentModelMap);
      }).then((_) => {
        getTradeChannels(salesOrg).then((v) => {
          setTradeChannels(v.result);
        })
        
      });
    }, [tradeSubtradeConfig,doneLoading,salesOrg]);
  
  const handleSubtradeChannels = (value:any) => {
    setEditedRowTradeChannels((value &&  typeof value == 'string') ? value : "*");
    if(value!=="*"){
      getSubTradeChannels(salesOrg,value).then((v) => {
        setSubTradeChannels(v.result);
      })
    }else{
      setSubTradeChannels("");
    }
  }
    const modalBody = (
      <div style={modalStyle} className={classes.paper} >
      <Typography variant="h4" className={classes.modalTitle} paragraph>Add Trade & Sub-Trade Configuration:</Typography>
      <Grid container spacing={2}  className={classes.modalGrid}>
        <Grid item xs={14} md={14} xl={12}>
          <Typography variant="subtitle1" className={classes.modalText} paragraph>
            
          </Typography>
          <Card className={classes.modalCard}>
            <CardContent>
            <Grid container rowSpacing={3} className={classes.modalGrid}>
              <Grid item xs={6} md={6} xl={6}>
                <InputLabel >Trade Channel</InputLabel>
                <Select label="Trade Channel" required placeholder='Trade Channel'  value={editedRowTradeChannels}
                    inputProps={{name: 'Trade Channel',}}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      handleSubtradeChannels(e.target.value);
                      }}
                    >
                    <MenuItem key='*' value='*'> All</MenuItem>
                    {(tradeChannels)?(Object.entries(tradeChannels).map((so: any, i: number) => (
                      
                        <MenuItem key={so[1].code} value={so[1].code}>
                          { so[1].text}
                        </MenuItem>
                        ))):(<div></div>)}
                </Select>
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Sub-Trade Channel</InputLabel>
                <Select label="Sub-Trade Channel"  value={editedRowSubTradeChannels}
                    className={classes.modalInput}
                    onChange={(e) => { 
                      setEditedRowSubTradeChannels((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*") 
                      }}>
                      <MenuItem key='*' value='*'>All</MenuItem>
                    {(subTradeChannels)?(Object.entries(subTradeChannels).map((so: any, i: number) => (
                      
                        <MenuItem key={so[1].code} value={so[1].code}>
                          {so[1].text}
                        </MenuItem>
                        ))):(<div></div>)}
                </Select>
              </Grid>
              
              <Grid item xs={6} md={6} xl={6}>
                <InputLabel >FSV<Tooltip title="This number (%) is set to recognize and favor vending machine recommendations over 
convenience. The formula for predicting sales is: (Sales per unit * (FSV slider value /100))">
                <Help style={{paddingBottom: "7px", textAlign:"center"}} /></Tooltip></InputLabel>
                <Box sx={{ width: 300 }}><Slider
                  marks={marks}
                  step={10}
                  value={fsvVal}
                  valueLabelDisplay="auto"
                  min={MIN}
                  max={MAX}
                  onChange={handleChange}
                  className={classes.modalInput}
                  valueLabelFormat={fsvVal=>fsvVal +' %' }
                  /></Box>
                
              </Grid>
              <Grid item xs={3} md={6} xl={6}>
                <InputLabel >Convenience<Tooltip title="This number (%) is set to recognize and favor convenience  recommendations over 
vending machine. The formula for predicting sales is: (Sales per unit * (convenience slider value /100))">
                <Help style={{paddingBottom: "7px", textAlign:"center"}}/></Tooltip></InputLabel>
                <Box sx={{ width: 300 }}>
                <Slider
                  marks={marks}
                  step={10}
                  value={convenienceVal}
                  valueLabelDisplay="auto"
                  min={MIN}
                  max={MAX}
                  onChange={handleConvenienceChange}
                  className={classes.modalInput}
                  valueLabelFormat={convenienceVal=>convenienceVal +' %' }
                /></Box>
              </Grid>
               
              </Grid>
              </CardContent>
            </Card>
            <div style={{ paddingRight: "5px", textAlign:"right"}}>
                  <React.Fragment>
                      <Tooltip title={"Save"}>
                          <IconButton onClick={handleModalSave}>
                              <SaveIcon />
                          </IconButton>
                      </Tooltip>
                      <Tooltip title={"Cancel"}>
                          <IconButton onClick={handleModalClose}>
                              <Clear />
                          </IconButton>
                      </Tooltip>
                  </React.Fragment>
                </div>
          </Grid>
        </Grid>
      </div>
    );
    return (
      <div className={classes.root}>
        {doneLoading && enabled ? (
          <TableAbstraction
            settingsKey="ADM_EQM"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Trade & Sub Trade`}>
                    <IconButton  onClick={() => {
                      handleModalClose();
                      setOpenEditWindow(true);
                    }}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                );
              },
            }}
            title="Trade & Sub-Trade Channel"
            columns={[
              {
                label: "Trade Channel",
                name: "text",
                options: {
                  searchable: true,
                  filter: false,
                },
              },
              {
                label: "Sub-Trade Channel",
                name: "config_text",
                options: {
                  searchable: true,
                  filter: false,
                },
              },
              {
                label: "Convenience",
                name: "convenience_percentage",
                options: {
                  searchable: true,
                  filter: false,
                  hint: "This number (%) is set to recognize and favor convenience  recommendations over vending machine. The formula for predicting sales is: (Sales per unit * (convenience slider value /100))",
                  renderCell: (props) => {
                    return `${props.row.convenience_percentage} %`
                  }
                },
              },
              {
                label: "FSV",
                name: "fsv_percentage",
                options: {
                  searchable: true,
                  filter: false,
                  hint: "This number (%) is set to recognize and favor vending machine recommendations over convenience. The formula for predicting sales is: (Sales per unit * (FSV slider value /100))",
                  renderCell: (props) => {
                    return `${props.row.fsv_percentage} %`
                  }
                },
              },
              {
                label: " ",
                name: "remove",
                options: {
                  filter: false,
                  setCellProps: () => ({ align: 'right' }),
                  renderCell: (params) => {
                    if(!!useCompact)
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <EditIcon 
                                fontSize="small"  
                                onClick={() => {handleEdit(params.row)}}/>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <DeleteIcon
                                fontSize="small" 
                                onClick={() => {setCurrent(params.row); setopenDeleteWindow(true);}} 
                              />
                            </Tooltip>
                          </React.Fragment>
                        );
                      else
                        return (
                            <React.Fragment>
                              <Tooltip title={"Edit"}>
                                <IconButton onClick={() => {handleEdit(params.row)}}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={"Delete"}>
                                <IconButton onClick={() => {setCurrent(params.row); setopenDeleteWindow(true);}}>
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </React.Fragment>
                          );
                  },
                },
              },
            ]}
            data={tradeSubtradeConfig}
          />
        ) : ( enabled ? (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>) : (
            <Alert severity="error">
              <AlertTitle><LockIcon/> Access Error</AlertTitle>   
              You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
            </Alert>
          )
        )}
         <Modal
                  open={openEditWindow}
                  onClose={handleModalClose}
              >
                  {modalBody}
  
              </Modal>
              <Dialog
              open={openDeleteWindow}
              onClose={handleModalClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this configuration ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={()=>{handleDelete(); setopenDeleteWindow(false);}} color="primary">
                  Yes
                </Button>
                <Button onClick={()=>{setEditedRow(undefined); setopenDeleteWindow(false);}} color="primary" autoFocus>
                  No
                </Button>
              </DialogActions>
        </Dialog>
      </div>
    );
}